<template>
  <categorical-insight-container v-if="hasData" :columns="1">
    <chart :options="chartOptions" style="height: 100%; position: relative;" />
  </categorical-insight-container>
</template>

<script>
  import CategoricalInsightContainer from './CategoricalInsightContainer';
  import {Chart} from 'highcharts-vue';

  const category = (min, max) => {
		if (min === max) return min;
		if (min === max - 1) return `${min}&${max}`;
		return `${min}-${max}`;
  };

	export default {
		name: 'CustomerAgeCounts',
		components: {Chart, CategoricalInsightContainer},
		props: {
			values: Array
		},
		computed: {
			hasData() {
				return this.values; // && this.values.length > 1;
      },

			chartOptions() {
				if (!this.hasData) return {};
				const nPoints = 150;

				let min = this.values[0][0];
				const max = this.values[this.values.length - 1][0];
				const binSize = Math.floor((max - min) / nPoints);
				const ageCountMap = this.values.reduce((m, v) => ({...m, [v[0]]: v[1]}), {});
				const data = [];
				while (true) {
					const upperBoundary = min + binSize;
					let total = 0;
					for (let i = min; i <= upperBoundary; i++)
						total += ageCountMap[i] || 0;
					data.push([category(min, upperBoundary), total]);
					min = upperBoundary + 1;
					if (min > max) break;
        }

				return {
					chart: {
						type: 'column'
					},
					title: {
						text: "Age"
					},
					xAxis: {
						categories: data.map(bin => bin[0]),
						crosshair: true
					},
					yAxis: {
						min: 0,
						title: {
							text: "Customer Count"
						}
					},
					tooltip: {
						headerFormat: '',
						pointFormat: '<b>{point.y}</b>',
						footerFormat: '',
						shared: true,
						useHTML: true
					},
					plotOptions: {
						column: {
							pointPadding: 0.2,
							borderWidth: 0
						}
					},
					series: [{
						showInLegend: false,
						name: "Age",
						data: data.map(bin => bin[1])
					}]
				};
			}
		}
	};
</script>

<style scoped>

</style>
